import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input } from 'antd';

import ActionButtons from './actionButtons';

const BankInfo = ({
  employee: { id: employeeID, bankInfo } = {},
  onBankInfoUpdate,
  ability,
}) => {
  const [form] = Form.useForm();
  const [isFormReadOnly, setIsFormReadOnly] = useState(
    (bankInfo && bankInfo.bank_name) || !ability.toEditEmployee
  );

  const isSensitiveFieldEditable = (isNew, ability) => {
    return (
      (isNew && ability.toAddSesitiveInfo) ||
      (!isNew && ability.toEditSesitiveInfo)
    );
  };

  const isNew = !bankInfo;

  return (
    <Form
      layout="vertical"
      size="large"
      className={`ant-form-custom ${isFormReadOnly ? 'ant-form-readOnly' : ''}`}
      form={form}
      initialValues={{
        id: employeeID,
        bank_name: bankInfo && bankInfo.bank_name,
        account_number: bankInfo && bankInfo.account_number,
        branch: bankInfo && bankInfo.branch,
        ifsc_code: bankInfo && bankInfo.ifsc_code,
      }}
      onFinish={(values) => {
        setIsFormReadOnly(!isFormReadOnly);
        onBankInfoUpdate(values);
      }}
    >
      <Row>
        <Col flex="auto" style={{ textAlign: 'right' }}>
          {ability.toEditEmployee && (
            <ActionButtons
              showEditBtn={isFormReadOnly}
              onEditClick={() => setIsFormReadOnly(!isFormReadOnly)}
              onCancelClick={() => {
                setIsFormReadOnly(!isFormReadOnly);
                form.resetFields();
              }}
            />
          )}
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={12}>
          <Form.Item
            label="Bank Name"
            name="bank_name"
            rules={[{ required: true, message: 'Please input Bank Name!' }]}
          >
            <Input placeholder="Bank Name" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Account Number"
            name="account_number"
            rules={
              isSensitiveFieldEditable(isNew, ability) && [
                { required: true, message: 'Please input Account Number!' },
              ]
            }
          >
            <Input
              placeholder="Account Number"
              disabled={
                isFormReadOnly ||
                !isSensitiveFieldEditable(isNew, ability)
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={12}>
          <Form.Item
            label="Branch"
            name="branch"
            rules={[{ required: true, message: 'Please input Branch!' }]}
          >
            <Input placeholder="Branch" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="IFSC Code"
            name="ifsc_code"
            rules={[{ required: true, message: 'Please input IFSC Code!' }]}
          >
            <Input
              placeholder="IFSC Code"
              disabled={isFormReadOnly}
              maxLength="15"
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
    </Form>
  );
};

BankInfo.defaultProps = {};

BankInfo.propTypes = {
  employee: PropTypes.object.isRequired,
  onBankInfoUpdate: PropTypes.func.isRequired,
  ability: PropTypes.object.isRequired,
};

export default BankInfo;
